<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
  >
    <path d="M18 3.25C18 1.45507 16.5449 0 14.75 0H3.25C1.45507 0 0 1.45507 0 3.25V14.75C0 16.5449 1.45507 18 3.25 18H9.02182C8.72526 17.5368 8.48584 17.0335 8.3135 16.5H3.25C2.2835 16.5 1.5 15.7165 1.5 14.75V5.5H16.5V8.3135C17.0335 8.48584 17.5368 8.72526 18 9.02182V3.25ZM3.25 1.5H14.75C15.7165 1.5 16.5 2.2835 16.5 3.25V4H1.5V3.25C1.5 2.2835 2.2835 1.5 3.25 1.5ZM20 14.5C20 11.4624 17.5376 9 14.5 9C11.4624 9 9 11.4624 9 14.5C9 17.5376 11.4624 20 14.5 20C17.5376 20 20 17.5376 20 14.5ZM14.5 14.5H16.5C16.7761 14.5 17 14.7239 17 15C17 15.2762 16.7761 15.5 16.5 15.5H14C13.7268 15.5 13.5048 15.2809 13.5001 15.0089L13.5 14.9999V11.9999C13.5 11.7238 13.7239 11.4999 14 11.4999C14.2761 11.4999 14.5 11.7238 14.5 11.9999L14.5 14.5Z" />
  </svg>
</template>
